import { render, staticRenderFns } from "./historyGrid.vue?vue&type=template&id=18949e16&scoped=true&"
import script from "./historyGrid.vue?vue&type=script&lang=js&"
export * from "./historyGrid.vue?vue&type=script&lang=js&"
import style0 from "./historyGrid.vue?vue&type=style&index=0&id=18949e16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18949e16",
  null
  
)

export default component.exports